module.exports = __webpack_public_path__ + "img/suit-12.16e0a244.png";